
import axios from "axios";
import { api_url } from "./Environment";
const EARLY_ACCESS = `${api_url}api/early-access`;
const COMPANY_REGISTER = `${api_url}api/company-register`;


export const joinEarlyAccess = async (payload) => {
  try {
    const response = await axios.post(EARLY_ACCESS, payload);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error.message;
  }
};

export const registerCompany = async (payload) => {
  try {
    const response = await axios.post(COMPANY_REGISTER, payload);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error.message;
  }
};